import { Link } from "@/components/common/Link";
const galleryItems = [{
  title: "Modern Austin Villa",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/austin_villa_listing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/austin_villa_listing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/austin_villa_listing.png-wvc-sizes",
  link: "/FindHomePage",
  alt: "Modern luxury villa in Austin across the country with owner financing"
}, {
  title: "Houston Family Estate",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/houston_estate_listing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/houston_estate_listing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/houston_estate_listing.png-wvc-sizes",
  link: "/FindHomePage",
  alt: "Spacious family home in Houston with private financing"
}, {
  title: "Dallas Heights Condo",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/dallas_condo_listing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/dallas_condo_listing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/dallas_condo_listing.png-wvc-sizes",
  link: "/FindHomePage",
  alt: "High-rise condo in Dallas with flexible payment terms"
}, {
  title: "San Antonio Ranch",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/san_antonio_ranch_listing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/san_antonio_ranch_listing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/san_antonio_ranch_listing.png-wvc-sizes",
  link: "/FindHomePage",
  alt: "Expansive ranch property in San Antonio with owner financing"
}];
export default function FeaturedPrivateListings() {
  return <section data-section-id="261642" id="featured-private-listings" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-primary font-default mb-4 tracking-tight">
            Featured Private Listings
          </h2>
          <p className="text-secondary text-lg max-w-2xl mx-auto font-default">
            Explore exclusive owner-financed properties across the country. Secure your dream home without traditional bank hurdles.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {galleryItems.map((item, i) => <Link key={i} to={item.link} className="group relative overflow-hidden rounded-lg shadow-md block aspect-square sm:aspect-[4/3] lg:aspect-[3/4] border border-border/50" data-index={i}>
              <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              {}
              <div className="absolute top-4 right-4 bg-accent-foreground text-primary-foreground px-3 py-1 rounded-md text-xs font-bold font-default shadow-sm z-10">
                OWNER FINANCED
              </div>
              
              <div className="absolute inset-0 bg-primary/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-4 text-center backdrop-blur-sm">
                <h3 className="text-primary-foreground text-2xl font-bold font-default tracking-tight uppercase translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                  {item.title}
                </h3>
                
                <div className="mt-4 flex flex-col items-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                  <span className="text-primary-foreground/90 font-mono text-lg font-semibold">
                    $15,000 DOWN
                  </span>
                  <span className="text-primary-foreground/80 font-mono text-sm">
                    $1,850 / MO
                  </span>
                  <span className="mt-4 inline-block border-b-2 border-accent-foreground pb-1 text-primary-foreground text-xs uppercase tracking-widest">
                    View Details
                  </span>
                </div>
              </div>
            </Link>)}
        </div>
      </div>
    </section>;
}